module.exports = __webpack_public_path__ + "static/media/cu.0b42edab.svg";